// extracted by mini-css-extract-plugin
module.exports = {"main":"nav_main__eGeDt","atv":"nav_atv__nR_RS","btnIcon":"nav_btnIcon__79_iO"};